import { ItemViewModel, ItemViewModel1 } from '../ItemViewModel';

export class GQuotationSaveModel {

    public Id: number;
    public vehicle: ItemViewModel1;
    public customer: ItemViewModel1;
    public vehicleNumber: string;
    public odometer: string;
    public driverName: string;
    public driverPhone: string;
    public quoteDate: Date;
    public subject: string;
    public note: string;
    public quoteNumber: string;
    public customerCode: string;
    public vat?: number;
    public werahouse: ItemViewModel1;
    public gQuotationDetail: GQuotationDetail[];
    public gQuotationTags: GQuotationTags[];
    public gQuotationAttachments: GQuotationAttachments[];
    public serviceTotal?: number;
    public partsTotal?: number;
    public totalDiscount?: number;
    public totalVat?: number;
    public total?: number;
    public attachment: string;
    public file: any = [];

}

export class SaveGQuotationRequest {

    public id: number;
    public uniqueId: string;
    public vehicle: ItemViewModel1;
    public customer: ItemViewModel1;
    public vehicleNumber: string;
    public odometer: string;
    public driverName: string;
    public driverPhone: string;
    public quoteDate: Date;
    public subject: string;
    public note: string;
    public quoteNumber: string;
    public customerCode: string;
    public vat?: number;
    public werahouse: ItemViewModel1;
    public gQuotationDetail: GQuotationDetail[];
    public gQuotationTags: GQuotationTags[];
    public gQuotationAttachments: GQuotationAttachments[];
    public serviceTotal?: number;
    public partsTotal?: number;
    public totalDiscount?: number;
    public totalVat?: number;
    public total?: number;
    public attachment: string;
    public file: any = [];

}

export class GQuotationDetail{
    public id: number;
    public gQuotationId: number;
    public itemName: string;
    public type: string;
    public quantity: number;
    public rate: number;
    public vatAmount: number;
    public discountRate: number;
    public discountPercentage: number;
    public discountAmount: number;
    public totalAmount: number;
    public totalAmountWithVat: number;
}

export class GQuotationTags{
    public id: number;
    public gQuotationId: number;
    public tag: string;
}

export class GQuotationAttachments{
    public id: number;
    public gQuotationId: number;
    public attachment: string;
}